// eslint-disable-next-line import/no-default-export
export default {
	LANDING: '/',
	QUESTIONS: '/questions',
	START: '/start',
	RESULTS: '/results/:key',
	RESULTS_PDF: '/results/:key/pdf-content',
}
